module.exports = {"title":"Voorstelling boek Gedachtenis","date":"2013-04-01T00:00:00Z","layout":"post","attachment":"Gedachtenis.pdf","linktext":"Lees Kennismaking","body":"<p>Presentatie van <strong>het boek</strong> over <strong>het thema gedachtenis</strong>, belicht vanuit de films: <strong>En waar de sterre bleef stille staan</strong>, <strong>Agora</strong> en <strong>Des hommes et des dieux</strong>.\nU kan het boek bestellen in onze rubriek <a href=\"/webshop/\">Webshop</a></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./blog/2015-01-05-BoekGedachtenis/index.md
// module id = 967
// module chunks = 0